import { FileText } from 'lucide-react';
import './CBSEDisclosure.css';

const CBSEDisclosure = () => {
  const generalInfo = [
    { sr: 1, info: 'Name of the School', details: 'BIHANI CHILDREN\'S ACADEMY' },
    { sr: 2, info: 'Affiliation No.', details: '1730128' },
    { sr: 3, info: 'School Code', details: '10494' },
    { sr: 4, info: 'Complete Address', details: 'Bihani Children\'s Academy, Gagan Path, Jawahar Nagar, Sri Ganganagar (Raj) 335001' },
    { sr: 5, info: 'Principal Name & Qualific.', details: 'MRS. NALINI DHINGRA (PRINCIPAL)' },
    { sr: 6, info: 'School Email Id', details: '10494@cbseshiksha.in' },
    { sr: 7, info: 'Contact (Landline/Mobile)', details: '0154-2460807, 2461807, 9982099392' },
  ];

  const documents = [
    { sr: 1, info: 'Copies of affiliation/Upgradation letter and recent extension of affiliation if any.', pdf: '/Affilation Letter (2024 to 2029).pdf' },
    { sr: 2, info: 'Copies of Societies/Trust/Company Registration/Renewal Certificate, as applicable', pdf: '/Trust Registration Copy.pdf' },
    { sr: 3, info: 'Copy of no objection certificate (NOC) issued, If applicable, by the state Govt./UT', pdf: '/NOC State Govt.pdf' },
    { sr: 4, info: 'Copies of recognition certificate under RTE ACT, 2009, and IT\'s renewal if applicable', pdf: '/Recognition Certificate Under RTE Act.2009.pdf' },
    { sr: 5, info: 'Copy of valid building safety certificate as per the national building code', pdf: '/building-safety.pdf' },
    { sr: 6, info: 'Copy of valid fire safety certificate issued by the competent authority', pdf: '/safety certificate.pdf' },
    { sr: 7, info: 'Copy of the DEO certificate submitted by the school for affiliation/upgradation/extension of affiliationor self certificate by school', pdf: '/Affilation Letter (2024 to 2029) (1).pdf' },
    { sr: 8, info: 'Copies of valid water, health and sanitation certificates', pdf: '/water-safety.pdf' },
    { sr: 9, info: 'Certificate of land', pdf: '/Land Certicicate.pdf' },
    { sr: 10, info: 'Mandatory Public Disclosure', pdf: '/Mandatory Disclosure Details _ SARAS 7.0.pdf' },
  ];

  const academicsHeaders = [
    { sr: 1, doc: 'Fees structure of the school.', pdf: '/Fee-2026 (2).pdf' },
    { sr: 2, doc: 'Annual Academic Calendar.', pdf: '/ACTIVITY CALENDER 2026-27 - 060426 (2).pdf' },
    { sr: 3, doc: 'List of School Management Committee (SMC)', pdf: '/BCA Managing Committee New (2).pdf' },
    { sr: 4, doc: 'List of Parents Teachers Association (PTA) Members', pdf: '/pta.pdf' },
  ];

  const resultClassX = [
    { sr: 1, year: '2025-26', registered: 155, passed: 155, percentage: '100%' },
    { sr: 1, year: '2024-25', registered: 161, passed: 161, percentage: '100%' },
    { sr: 2, year: '2023-24', registered: 158, passed: 158, percentage: '100%' },
    { sr: 3, year: '2022-23', registered: 115, passed: 115, percentage: '100%' },
    { sr: 4, year: '2021-22', registered: 141, passed: 141, percentage: '100%' },
    { sr: 5, year: '2020-21', registered: 144, passed: 144, percentage: '100%' },
    { sr: 6, year: '2019-20', registered: 163, passed: 163, percentage: '100%' },
  ];

  const resultClassXII = [
    { sr: 1, year: '2025-26', registered: 134, passed: 131, percentage: '97.76%' },
    { sr: 1, year: '2024-25', registered: 102, passed: 94, percentage: '92.15%' },
    { sr: 2, year: '2023-24', registered: 129, passed: 124, percentage: '96.12%' },
    { sr: 3, year: '2021-22', registered: 137, passed: 136, percentage: '99.30%' },
    { sr: 4, year: '2020-21', registered: 153, passed: 153, percentage: '100%' },
    { sr: 5, year: '2019-20', registered: 151, passed: 146, percentage: '96.70%' },
  ];

  const staffTeaching = [
    { sr: 1, info: 'Principal', details: 'MRS. NALINI DHINGRA' },
    { sr: 2, info: 'Total No. of teachers', details: '64' },
    { sr: '', info: 'PGT', details: '17' },
    { sr: '', info: 'TGT', details: '27' },
    { sr: '', info: 'PRT', details: '15' },
    { sr: 3, info: 'Teachers section ratio', details: '1:19' },
    { sr: 4, info: 'Details of special educator', details: 'Archana Maheshwari' },
    { sr: 5, info: 'Details of counsellor and wellness teacher', details: 'Mrs.Kamini Bajaj' },
  ];

  const infrastructure = [
    { sr: 1, info: 'Total campus area of the school (in square mtr)', details: '18778' },
    { sr: 2, info: 'No. and size of the classroom (in sq ft mtr)', details: 'No. of rooms: 64\nSize: 440 sq mtr' },
    { sr: 3, info: 'No. and size of laboratories including computer labs (in Sq mtr)', details: 'No. of Laboratories: 06\nSize: 880 sq mtr' },
    { sr: 4, info: 'Internet facility (Y/N)', details: 'Yes' },
    { sr: 5, info: 'No. of Girls Toilets', details: '13' },
    { sr: 6, info: 'No. of Boys Toilets', details: '13' },
    { sr: 7, info: 'Link of Youtube video of the inspection of school covering the infrastructure of the school', details: 'View', link: 'https://youtube.com/your-video' },
  ];

  const ViewButton = ({ pdfUrl }) => (
    <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="cbse-view-btn">
      <FileText size={16} />
      View
    </a>
  );

  const Table = ({ headers, data, type = 'normal' }) => (
    <div className="cbse-table-wrapper">
      <table className="cbse-table">
        <thead>
          <tr>
            {type === 'result' ? (
              <>
                <th>Sr. No.</th>
                <th>Year</th>
                <th>No. of Registered Students</th>
                <th>No. of Students passed</th>
                <th>Pass Percentage</th>
                <th>Remarks</th>
              </>
            ) : type === 'academics' ? (
              <>
                <th>Sr. No.</th>
                <th>Document/Information</th>
                <th>Upload Documents</th>
              </>
            ) : type === 'infrastructure' ? (
              <>
                <th>Sr. No.</th>
                <th>Information</th>
                <th>Details</th>
              </>
            ) : (
              <>
                <th>Sr. No.</th>
                <th>Information</th>
                <th>Details</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              {type === 'result' ? (
                <>
                  <td>{row.sr}</td>
                  <td>{row.year}</td>
                  <td>{row.registered}</td>
                  <td>{row.passed}</td>
                  <td>{row.percentage}</td>
                  <td></td>
                </>
              ) : type === 'academics' ? (
                <>
                  <td>{row.sr}</td>
                  <td>{row.doc}</td>
                  <td><ViewButton pdfUrl={row.pdf} /></td>
                </>
              ) : type === 'infrastructure' ? (
                <>
                  <td>{row.sr}</td>
                  <td>{row.info}</td>
                  <td className="cbse-multiline">
                    {row.link ? (
                      <ViewButton pdfUrl={row.link} />
                    ) : (
                      row.details
                    )}
                  </td>
                </>
              ) : (
                <>
                  <td>{row.sr}</td>
                  <td>{row.info}</td>
                  <td>
                    {row.pdf ? (
                      <ViewButton pdfUrl={row.pdf} />
                    ) : (
                      row.details
                    )}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="cbse-container">
      {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>CBSE DISCLOSURE</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>CBSE Disclosure</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="cbse-content">
        {/* General Information */}
        <section className="cbse-section">
          <h2 className="cbse-section-title">CBSE MANDATORY DISCLOSURE</h2>
          
          <div className="cbse-subsection">
            <h3 className="cbse-subsection-title">General Information:</h3>
            <Table headers={['Sr. No.', 'Information', 'Details']} data={generalInfo} />
          </div>

          {/* Document and Information */}
          <div className="cbse-subsection">
            <h3 className="cbse-subsection-title">Document and Information:</h3>
            <Table headers={['Sr. No.', 'Information', 'Details']} data={documents} />
          </div>

          {/* Result and Academics */}
          <div className="cbse-subsection">
            <h3 className="cbse-subsection-title">Result and Academics:</h3>
            <Table headers={['Sr. No.', 'Document/Information', 'Upload Documents']} data={academicsHeaders} type="academics" />

            <div className="cbse-result-subsection">
              <h4>Result Class: X</h4>
              <Table headers={['Sr. No.', 'Year', 'No. of Registered', 'No. of Passed', 'Pass %', 'Remarks']} data={resultClassX} type="result" />
            </div>

            <div className="cbse-result-subsection">
              <h4>Result Class: XII</h4>
              <Table headers={['Sr. No.', 'Year', 'No. of Registered', 'No. of Passed', 'Pass %', 'Remarks']} data={resultClassXII} type="result" />
            </div>
          </div>

          {/* Staff Teaching */}
          <div className="cbse-subsection">
            <h3 className="cbse-subsection-title">Staff (Teaching)</h3>
            <Table headers={['Sr. No.', 'Information', 'Details']} data={staffTeaching} />
          </div>

          {/* School Infrastructure */}
          <div className="cbse-subsection">
            <h3 className="cbse-subsection-title">School Infrastructure</h3>
            <Table headers={['Sr. No.', 'Information', 'Details']} data={infrastructure} type="infrastructure" />
          </div>
        </section>
      </div>
    </div>
  );
};

export default CBSEDisclosure;